import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ItemVisual } from '../components/ItemVisual';
import { audio } from '../core/audio';
import { useActivity } from './useActivity';

export function PatternChoice({ activity, onComplete }) {
  const { state, answer, showHint } = useActivity(activity, onComplete);
  useEffect(() => { const t = setTimeout(() => audio.playVoice(activity.voice), 400); return () => clearTimeout(t); }, [activity.id]); // eslint-disable-line

  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-9 px-5" data-testid="activity-pattern">
      <div className="flex items-center gap-2 bg-white/70 backdrop-blur rounded-[2rem] px-4 py-3" style={{ border: '4px solid #fff' }}>
        {activity.pattern.map((it, i) => <ItemVisual key={i} item={it} size={54} />)}
        <div className="w-[54px] h-[54px] rounded-2xl border-4 border-dashed border-navy/30 flex items-center justify-center font-heading text-2xl text-navy/40">?</div>
      </div>
      <div className="flex gap-5">
        {activity.choices.map((ch) => {
          const isCorrect = ch.id === activity.correct;
          return (
            <motion.button key={ch.id} data-testid={`choice-${ch.id}`} whileTap={{ scale: 0.92 }}
              animate={state === 'correct' && isCorrect ? { scale: [1, 1.15, 1.08] } : showHint && isCorrect ? { scale: [1, 1.06, 1] } : {}}
              transition={showHint && isCorrect ? { repeat: Infinity, duration: 1.2 } : {}}
              onClick={() => answer(isCorrect)}
              className="rounded-[2rem] p-3 bg-white/80 backdrop-blur min-w-[96px] min-h-[96px]"
              style={{ border: '5px solid #fff', boxShadow: state === 'correct' && isCorrect ? '0 0 0 6px #FFD166' : '0 10px 24px rgba(29,53,87,0.15)' }}>
              <ItemVisual item={ch} size={88} />
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
